import React, { Fragment, useRef } from 'react';
import { useDispatch } from 'react-redux';

import ForwardToInboxRoundedIcon from '@mui/icons-material/ForwardToInboxRounded';

import { sendPasswordChangeLink } from '../../../actions/security';
import { useModalToggle } from '../../../hooks/useModalToggle';
import withTranslations from '../../../utils/HighOrderComponent';
import LoadingIndicator from '../../Reusable/LoadingIndicator';
import CustomModal from '../../Reusable/Modal/CustomModal';
import ContactForm from './ContactForm';

const LoginForgottenPassword = (props) => {
  const { t, loading } = props || {},
    { Labels, Form, Modals, Buttons, NotificationMessages } = t || {};
  const submitRef = useRef();
  const dispatch = useDispatch();
  const [showModal, toggleModal] = useModalToggle(false);

  const onSubmitHandler = (email) => {
    dispatch(sendPasswordChangeLink(email, NotificationMessages, toggleModal));
  };

  return (
    <Fragment>
      <p className="mb-0">
        <span
          className="fw-semibold text-info text-decoration-underline"
          onClick={toggleModal}
          role="button"
        >
          {Labels?.forgotPassword}
        </span>
      </p>
      {showModal && (
        <CustomModal
          show={showModal}
          hideModal={toggleModal}
          title={Modals?.title}
          submitRef={submitRef}
          modalSize="small"
          customSaveButtonLabel={Buttons?.send}
          customSaveButtonIcon={<ForwardToInboxRoundedIcon />}
        >
          <LoadingIndicator loading={loading} />
          <ContactForm
            submitRef={submitRef}
            translations={Form}
            onSubmit={onSubmitHandler}
          />
        </CustomModal>
      )}
    </Fragment>
  );
};

export default withTranslations(
  LoginForgottenPassword,
  'LoginForgottenPassword'
);
